import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { Button, IconButton, Snackbar, Tooltip } from '@mui/joy';
import { AlertDialogModal } from './AlertDialogModal';
import {statusCodeToMessage} from "@/utils/errors.js";
import DoneIcon from '@mui/icons-material/Done';
import MenuItem from '@mui/joy/MenuItem';

export function ConfirmAction({ id, type='icon', useAction, icon, texts, actionColor, redirectOnSuccess, redirectTo = '..', errorOverrides }) {
  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [performAction] = useAction();

  function handleAction(e) {            
    e.stopPropagation();
    e.stopMenuClose = true;
    setOpen(true);    
  }

  function onBlur(e) {
    e.stopPropagation();
    e.stopMenuClose = true;
  }

  async function onConfirm() {
    const result = await performAction({id});
    if (result.error) {
      throw new Error(statusCodeToMessage(result.error.status, errorOverrides));
    } else if (redirectOnSuccess) {
      navigate(redirectTo);
    } else if (texts.successMessage != null) {
      setShowSuccess(true)
    }
  }

  return <>
    {type === 'icon' ? (
      <Tooltip title={texts?.tooltip} size="sm">
        <IconButton size="sm" variant="plain" onClick={handleAction}>{icon}</IconButton>
      </Tooltip>
    ) : type === 'menu-item' ? (
      <MenuItem onClick={handleAction}  onBlur={onBlur}>{icon} {texts.action}</MenuItem>
    ) : (
      <Button variant="outlined" color="neutral" onClick={handleAction} startDecorator={icon}>{texts.action}</Button>
    )}    

    <AlertDialogModal open={open} setOpen={setOpen} props={{
      title: texts.title,
      message: texts.message,
      confirmActionText: texts.action,
      confirmActionColor: actionColor,
      onConfirm,
    }} />
    {texts?.successMessage && <Snackbar
      color="success"
      variant="soft"
      startDecorator={<DoneIcon />}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={showSuccess}
      onClose={() => setShowSuccess(false)}
    >{texts?.successMessage}</Snackbar>}
  </>
}
